import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
} from 'react'
import Button, { TYPES } from '../../Button/index'
import EllipsisHorizontalIcon from '../../Icon/icons/EllipsisHorizontal/index'

/**
 * @param {Object} props - The props
 * @param {JSX.Element} props.primaryButtons - The buttons always visible
 * @param {JSX.Element} props.hiddenButtons - The buttons hidden in the three dots menu
 * @returns {JSX.Element} DetailPageV3ActionButtons
 */

const DetailPageV3ActionButtons = (props) => {
  const {
    primaryButtons = null,
    hiddenButtons = null,
  } = props

  const [isExpanded, setIsExpanded] = useState(false)
  const dropdownRef = useRef(null)

  const dropdownClassName = [
    'detail-page-v3__action-buttons-dropdown',
    isExpanded ? 'detail-page-v3__action-buttons-dropdown--expanded' : null,
  ].filter((cls) => !!cls).join(' ')

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsExpanded(false)
    }
  }, [dropdownRef])

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [handleClickOutside])

  return (
    <div className="detail-page-v3__action-buttons">
      <div className="detail-page-v3__action-buttons-container">
        {primaryButtons}
        {
          !!hiddenButtons && <>
            <div ref={dropdownRef}>
              <Button
                type={TYPES.ICON}
                iconSvg={<EllipsisHorizontalIcon />}
                onClick={() => setIsExpanded(!isExpanded)}
                className="detail-page-v3__action-button detail-page-v3__action-button--more"
              >
              </Button>
            </div>
            <div className={dropdownClassName}>
              {hiddenButtons}
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default DetailPageV3ActionButtons
